// src/components/charts/PieChartScopes.js

import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

import "./PieChartScopes.css";

/**
 * Colours MUST stay in sync with legend
 */
const COLOURS = {
  scope1: "#134E4A", // dark green
  scope2: "#2FAF7A", // primary green
  scope3: "#96bdab", // light green
};

export default function PieChartScopes({ summary, captureId }) {
  const data = [
    {
      name: "Scope 1",
      value: Number(summary?.scope_1_kgco2e || 0),
      colour: COLOURS.scope1,
    },
    {
      name: "Scope 2",
      value: Number(summary?.scope_2_kgco2e || 0),
      colour: COLOURS.scope2,
    },
    {
      name: "Scope 3",
      value: Number(summary?.scope_3_kgco2e || 0),
      colour: COLOURS.scope3,
    },
  ];

  const hasData = data.some((d) => d.value > 0);

  if (!hasData) {
    return <p className="chart-empty">No emissions data available</p>;
  }

  return (
    <div id={captureId} className="pie-chart-wrapper">
      {/* CHART */}
      <div className="pie-chart">
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              innerRadius={55} // smaller hole = thicker ring
              outerRadius={95} // slightly larger overall size
              paddingAngle={2}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.colour} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* LEGEND */}
      <div className="pie-legend">
        {data.map((item) => (
          <div key={item.name} className="legend-row">
            <span className="legend-dot" style={{ backgroundColor: item.colour }} />
            <span className="legend-label">{item.name}</span>
            <span className="legend-value">{item.value.toLocaleString()} kg CO₂e</span>
          </div>
        ))}
      </div>
    </div>
  );
}
